var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEcm004(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18 10V20C18 20.6 18.4 21 19 21C19.6 21 20 20.6 20 20V10H18Z",
    fill: "#035A4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11 10V17H6V10H4V20C4 20.6 4.4 21 5 21H12C12.6 21 13 20.6 13 20V10H11Z",
    fill: "#035A4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10 10C10 11.1 9.1 12 8 12C6.9 12 6 11.1 6 10H10Z",
    fill: "#035A4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18 10C18 11.1 17.1 12 16 12C14.9 12 14 11.1 14 10H18Z",
    fill: "#035A4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14 4H10V10H14V4Z",
    fill: "#035A4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17 4H20L22 10H18L17 4Z",
    fill: "#035A4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7 4H4L2 10H6L7 4Z",
    fill: "#035A4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10C6 11.1 5.1 12 4 12C2.9 12 2 11.1 2 10H6ZM10 10C10 11.1 10.9 12 12 12C13.1 12 14 11.1 14 10H10ZM18 10C18 11.1 18.9 12 20 12C21.1 12 22 11.1 22 10H18ZM19 2H5C4.4 2 4 2.4 4 3V4H20V3C20 2.4 19.6 2 19 2ZM12 17C12 16.4 11.6 16 11 16H6C5.4 16 5 16.4 5 17C5 17.6 5.4 18 6 18H11C11.6 18 12 17.6 12 17Z",
    fill: "#035A4B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcm004);
export default __webpack_public_path__ + "static/media/ecm004.46efb65310f129a6921536057ce5261c.svg";
export { ForwardRef as ReactComponent };